import React from "react";
import { Row } from "react-bootstrap";

function Update() {
  return (
    <div className="faq-container">
      <p>Update Content... Under construction</p>
    </div>
  );
}

export default Update;
